import styled from "styled-components";

export const ContainerCustos = styled.div`
  display: inline-flex;
  gap: 5px;
  flex-wrap: wrap;
  align-items: center;
`;

export const ChipCusto = styled.span`
  display: inline-flex;
  align-items: center;
  border: 1px solid black;
  border-radius: 15px;
  padding: 5px 10px;
  white-space: nowrap;
`;

export const LabelCusto = styled.span`
  line-height: 1;
`;

export const BotaoRemover = styled.span`
  color: red;
  margin-left: 5px;
  cursor: pointer;
  line-height: 1;

  &:hover {
    opacity: 0.7;
  }
`;
